import { Tabs } from 'src/design/molecules/Tabs';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Header } from 'src/design/organisms/Header';
import {
  isAIAssistantTab,
  readAIAssistantTab,
  writeAIAssistantTab,
} from 'src/routes/Settings/AIAssistant/aiAssistantSearchParams';
import { ConversationsTab } from 'src/routes/Settings/AIAssistant/ConversationsTab';
import { FeedbackTab } from 'src/routes/Settings/AIAssistant/FeedbackTab';
import { KnowledgeTab } from 'src/routes/Settings/AIAssistant/KnowledgeTab';
import { OverviewTab } from 'src/routes/Settings/AIAssistant/OverviewTab';
import { SqlAuditTab } from 'src/routes/Settings/AIAssistant/SqlAuditTab';
import { UsageTab } from 'src/routes/Settings/AIAssistant/UsageTab';

export const AIAssistantAudit: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = readAIAssistantTab(searchParams);

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [{ text: 'Settings' }, { text: 'F.I.R.E.' }],
        }}
        title="F.I.R.E."
        helpText="Review usage, cost, conversations, feedback, and SQL queries run on behalf of users for the AI assistant."
      />
      <Tabs
        value={tab}
        onChange={(value) => {
          if (isAIAssistantTab(value)) {
            setSearchParams((prev) => writeAIAssistantTab(prev, value));
          }
        }}
      >
        <Tabs.List>
          <Tabs.Tab value="overview">Overview</Tabs.Tab>
          <Tabs.Tab value="conversations">Conversations</Tabs.Tab>
          <Tabs.Tab value="feedback">Feedback</Tabs.Tab>
          <Tabs.Tab value="knowledge">Knowledge</Tabs.Tab>
          <Tabs.Tab value="sql-audit">SQL Audit</Tabs.Tab>
          <Tabs.Tab value="usage">Usage</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="overview" pt="md">
          <OverviewTab />
        </Tabs.Panel>
        <Tabs.Panel value="conversations" pt="md">
          <ConversationsTab />
        </Tabs.Panel>
        <Tabs.Panel value="feedback" pt="md">
          <FeedbackTab />
        </Tabs.Panel>
        <Tabs.Panel value="knowledge" pt="md">
          <KnowledgeTab />
        </Tabs.Panel>
        <Tabs.Panel value="sql-audit" pt="md">
          <SqlAuditTab />
        </Tabs.Panel>
        <Tabs.Panel value="usage" pt="md">
          <UsageTab />
        </Tabs.Panel>
      </Tabs>
    </>
  );
};
